export const currencyFormater = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
});
